import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiUpdateCommentRequest,
  DefaultApiAddCommentRequest,
  DefaultApiGetCommentRequest,
  DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest,
  DefaultApiGetMonthlyCardTransactionsForTheUserRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const updateComment = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateCommentRequest
) => {
  return await userApiDefaultApiFactory(instance).updateComment(params)
}

export const addComment = async (
  instance: AxiosInstance,
  params: DefaultApiAddCommentRequest
) => {
  return await userApiDefaultApiFactory(instance).addComment(params)
}

export const getComment = async (
  instance: AxiosInstance,
  params: DefaultApiGetCommentRequest
) => {
  return await userApiDefaultApiFactory(instance).getComment(params)
}

export const getMonthlyCardTransactionsForTheOrganization = async (
  instance: AxiosInstance,
  params: DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getMonthlyCardTransactionsForTheOrganization(params)
}

export const getMonthlyCardTransactionsForTheUser = async (
  instance: AxiosInstance,
  params: DefaultApiGetMonthlyCardTransactionsForTheUserRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getMonthlyCardTransactionsForTheUser(params)
}

// Do Not Remove this line ===@import api client===
